module.exports = __webpack_public_path__ + "media/banner1.7747ffef.mp4";